import React from 'react'
import firebaseui from 'firebaseui'
import { Redirect, RouteComponentProps } from 'react-router-dom'

import { Spinner } from '~/components'
import { auth, isAuthenticated, PROVIDERS_IDS } from '~/firebase'
import * as routes from '~/pages/routes'

import './style.css'


export default class SignIn extends React.Component<RouteComponentProps<any>> {
  state = {
    redirect: false,
    uiShown: false,
  }

  ui // = new firebaseui.auth.AuthUI(auth)

  uiConfig = {
    callbacks: {
      signInSuccess: (/*currentUser, credential, redirectUrl*/) => {
        this.setState({redirect: true})
        return false // don't redirect, we use router
      },
      uiShown: () => this.setState({uiShown: true})
    },
    credentialHelper: firebaseui.auth.CredentialHelper.NONE,
    signInFlow: 'popup',
    // signInSuccessUrl: '/dashboard', // don't redirect, we use router
    signInOptions: PROVIDERS_IDS,
    // Terms of service url.
    tosUrl: 'https://termsfeed.com/terms-conditions/ebf0ad85614bd0650b55c871d1424920'
  }

  componentDidMount() {
    setTimeout(() => {
      this.ui = new firebaseui.auth.AuthUI(auth)
      this.ui.start('#firebaseui-auth-container', this.uiConfig)
    }, 0)
  }

  componentWillUnmount() {
    this.ui.delete()
  }

  render() {

    if (isAuthenticated() || this.state.redirect)
      return <Redirect to={this.props.location.state ? this.props.location.state.from : routes.DASHBOARD}/>

    return (
      <>
        <div className="isoSignInPage sc-jzJRlG kERknP" data-rtl="ltr">
          <div className="isoLoginContentWrapper">
            <div className="isoLoginContent">
              <div className="isoLogoWrapper"><a href="/dashboard"><span>Cloud Mining</span></a></div>
              <div className="isoSignInForm" id="firebaseui-auth-container">
                {!this.state.uiShown && <div id="loader"><Spinner centered size={120}/></div>}
              </div>
              <span className="passwordHint">demo account:<br/>demo@demo.demo<br/>password: demodemo</span>
              <br/>
              <span className="passwordHint">admin@demo.demo<br/>password: admindemo</span>
            </div>
          </div>
        </div>
      </>
    )
  }
}

//   static firebaseUiDeleted = Promise.resolve();

//   componentDidMount() {
//     firebaseUiDeleted.then(() => {
//       this.ui = new firebaseui.auth.AuthUI(auth)
//       this.ui.start('#firebaseui-auth-container', this.uiConfig)
//     })
//   }

//   componentWillUnmount() {
//     SignIn.firebaseUiDeleted = this.ui.delete()
//   }
// }



// WEBPACK FOOTER //
// ./src/pages/SignIn/index.tsx